import { PerformanceActionTypes } from './performance.types'

//New Request
export const peformanceNewRequest = data => ({
    type: PerformanceActionTypes.PEFORMANCE_NEW_REQUEST,
    payload: data
})

export const peformanceNewRequestSuccess = data => ({
    type: PerformanceActionTypes.PEFORMANCE_NEW_REQUEST_SUCCESS,
    payload: data
})

export const peformanceNewRequestError = data => ({
    type: PerformanceActionTypes.PEFORMANCE_NEW_REQUEST_ERROR,
    payload: data
})

export const peformanceNewRequestStatus = data => ({
    type: PerformanceActionTypes.PEFORMANCE_NEW_REQUEST_STATUS,
    payload: data
})

//Request List
export const peformanceRequestListRequest = data => ({
    type: PerformanceActionTypes.PEFORMANCE_REQUEST_LIST_REQUEST,
    payload: data
})

export const peformanceRequestListRequestSuccess = data => ({
    type: PerformanceActionTypes.PEFORMANCE_REQUEST_LIST_REQUEST_SUCCESS,
    payload: data
})

export const peformanceRequestListRequestError = data => ({
    type: PerformanceActionTypes.PEFORMANCE_REQUEST_LIST_REQUEST_ERROR,
    payload: data
})

//New Review
export const peformanceNewReviewRequest = data => ({
    type: PerformanceActionTypes.PERFORMANCE_NEW_REVIEW_REQUEST,
    payload: data
})

export const peformanceNewReviewRequestSuccess = data => ({
    type: PerformanceActionTypes.PERFORMANCE_NEW_REVIEW_REQUEST_SUCCESS,
    payload: data
})

export const peformanceNewReviewRequestError = data => ({
    type: PerformanceActionTypes.PERFORMANCE_NEW_REVIEW_REQUEST_ERROR,
    payload: data
})

export const peformanceNewReviewRequestStatus = data => ({
    type: PerformanceActionTypes.PERFORMANCE_NEW_REVIEW_REQUEST_STATUS,
    payload: data
})

//Review List
export const peformanceReviewListRequest = data => ({
    type: PerformanceActionTypes.PEFORMANCE_REVIEW_LIST_REQUEST,
    payload: data
})

export const peformanceReviewListRequestSuccess = data => ({
    type: PerformanceActionTypes.PEFORMANCE_REVIEW_LIST_REQUEST_SUCCESS,
    payload: data
})

export const peformanceReviewListRequestError = data => ({
    type: PerformanceActionTypes.PEFORMANCE_REVIEW_LIST_REQUEST_ERROR,
    payload: data
})

//New Goal
export const peformanceNewGoalRequest = data => ({
    type: PerformanceActionTypes.PEFORMANCE_NEW_GOAL_REQUEST,
    payload: data
})

export const peformanceNewGoalRequestSuccess = data => ({
    type: PerformanceActionTypes.PEFORMANCE_NEW_GOAL_REQUEST_SUCCESS,
    payload: data
})

export const peformanceNewGoalRequestError = data => ({
    type: PerformanceActionTypes.PEFORMANCE_NEW_GOAL_REQUEST_ERROR,
    payload: data
})

export const peformanceNewGoalRequestStatus = data => ({
    type: PerformanceActionTypes.PEFORMANCE_NEW_GOAL_REQUEST_STATUS,
    payload: data
})

//Goal List
export const peformanceGoalListRequest = data => ({
    type: PerformanceActionTypes.PEFORMANCE_GOAL_LIST_REQUEST,
    payload: data
})

export const peformanceGoalListRequestSuccess = data => ({
    type: PerformanceActionTypes.PEFORMANCE_GOAL_LIST_REQUEST_SUCCESS,
    payload: data
})

export const peformanceGoalListRequestError = data => ({
    type: PerformanceActionTypes.PEFORMANCE_GOAL_LIST_REQUEST_ERROR,
    payload: data
})

//Goal Details
export const peformanceGoalDetailsRequest = data => ({
    type: PerformanceActionTypes.PEFORMANCE_GOAL_DETAILS_REQUEST,
    payload: data
})

export const peformanceGoalDetailsRequestSuccess = data => ({
    type: PerformanceActionTypes.PEFORMANCE_GOAL_DETAILS_REQUEST_SUCCESS,
    payload: data
})

export const peformanceGoalDetailsRequestError = data => ({
    type: PerformanceActionTypes.PEFORMANCE_GOAL_DETAILS_REQUEST_ERROR,
    payload: data
})

//Update Goal
export const peformanceUpdateGoalRequest = data => ({
    type: PerformanceActionTypes.PEFORMANCE_UPDATE_GOAL_REQUEST,
    payload: data
})

export const peformanceUpdateGoalRequestSuccess = data => ({
    type: PerformanceActionTypes.PEFORMANCE_UPDATE_GOAL_REQUEST_SUCCESS,
    payload: data
})

export const peformanceUpdateGoalRequestError = data => ({
    type: PerformanceActionTypes.PEFORMANCE_UPDATE_GOAL_REQUEST_ERROR,
    payload: data
})

export const peformanceUpdateGoalRequestStatus = data => ({
    type: PerformanceActionTypes.PEFORMANCE_UPDATE_GOAL_REQUEST_STATUS,
    payload: data
})

//Add Goal Comment
export const peformanceAddGoalCommentRequest = data => ({
    type: PerformanceActionTypes.PEFORMANCE_ADD_GOAL_COMMENT_REQUEST,
    payload: data
})

export const peformanceAddGoalCommentRequestSuccess = data => ({
    type: PerformanceActionTypes.PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_SUCCESS,
    payload: data
})

export const peformanceAddGoalCommentRequestError = data => ({
    type: PerformanceActionTypes.PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_ERROR,
    payload: data
})

export const peformanceAddGoalCommentRequestStatus = data => ({
    type: PerformanceActionTypes.PEFORMANCE_ADD_GOAL_COMMENT_REQUEST_STATUS,
    payload: data
})